import PanelPage from 'navigation/pages/PanelPage';
export default class EditAddress extends PanelPage {
    initialized() {
        super.initialized();
        const isCheckout = document.querySelector('.page.checkout');
        if (isCheckout) {
            this.modules.form.el.action += '?from=checkout';
            this.modules.form.action += '?from=checkout';
        }
    }
    resize() {
        super.resize();
    }
    flush() {
        super.flush();
    }
}
